import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'qvs-login-legal',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './login-legal.component.html',
  styleUrls: ['./login-legal.component.scss']
})
export class LoginLegalComponent implements OnInit {
  title = '';
  articleText = '';

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.title = data?.title ?? this.title;
      this.articleText = data?.articleText ?? this.articleText;
    });
  }
}
